import { createRouter, createWebHistory } from 'vue-router';
import store from '../store';

import ForgotPassword from '../components/ForgotPassword.vue';
import ResetPassword from '../components/ResetPassword.vue';
import EmailVerified from '../components/EmailVerified.vue';
import Unsubscribe from '../components/Unsubscribe.vue';
import AppEncapsulated from '../components/AppEncapsulated.vue';
import SearchMapExample from '../components/SearchMapExample.vue';
import UtahDrawInfo from '../components/UtahDrawInfo.vue';
import PremiumSuccess from '../components/PremiumSuccess.vue';
import PremiumCancel from '../components/PremiumCancel.vue';
import PaymentSuccess from '../components/PaymentSuccess.vue';
const routes = [
  {
    path: '/',
    name: 'Home',
    component: AppEncapsulated,
  },
  {
    path: '/utah-draw-info',
    name: 'UtahDrawInfo',
    component: UtahDrawInfo,
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword,
  },
  {
    path: '/email-verified',
    name: 'EmailVerified',
    component: EmailVerified
  },
  {
    path: '/unsubscribe',
    name: 'Unsubscribe',
    component: Unsubscribe
  },
  {
    path: '/search-map',
    name: 'SearchMap',
    component: SearchMapExample,
    meta: { requiresAuth: false }
  },
  {
    path: '/view-draw-odds',
    name: 'ViewDrawOdds',
    component: () => import('../components/ViewDrawOdds.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/saved-hunts',
    name: 'SavedHunts',
    component: () => import('../components/SavedHuntsMapView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/premium-success',
    name: 'PremiumSuccess',
    component: PremiumSuccess,
    meta: { requiresAuth: true }
  },
  {
    path: '/premium-cancel',
    name: 'PremiumCancel',
    component: PremiumCancel,
    meta: { requiresAuth: true }
  },
  {
    path: '/payment/success',
    name: 'PaymentSuccess',
    component: PaymentSuccess,
    meta: { requiresAuth: true }
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Navigation guard to check authentication for routes that require it
router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // Check if user is authenticated using the getter
    if (!store.getters.isAuthenticated) {
      // Redirect to home with signin parameter
      next({
        path: '/',
        query: { signin: 'true' }
      });
      // Show alert after navigation
      setTimeout(() => {
        alert('You must be signed in to access this page.');
      }, 100);
    } else {
      // User is authenticated, now check if email is verified
      const isEmailVerified = await checkEmailVerification();
      if (!isEmailVerified) {
        // Redirect to home with a message about email verification
        next({
          path: '/',
          query: { emailNotVerified: 'true' }
        });
        // Show alert after navigation
        setTimeout(() => {
          alert('Please verify your email address before accessing this page.');
        }, 100);
      } else {
        next();
      }
    }
  } else {
    next();
  }
});

// Helper function to check email verification status
async function checkEmailVerification() {
  try {
    const response = await fetch(process.env.VUE_APP_API_BASE_URL + '/api/customers/whoami', {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      }
    });
    
    if (response.ok) {
      const userData = await response.json();
      // Check if user has dateEmailVerified property and it's not null
      return userData.dateEmailVerified != null;
    } else {
      console.error('Failed to fetch user verification status');
      // If we can't check verification status, allow access to prevent blocking users
      return true;
    }
  } catch (error) {
    console.error('Error checking email verification:', error);
    // If we can't check verification status, allow access to prevent blocking users
    return true;
  }
}

export default router;
